import {
    Component,
    OnInit,
    Inject,
    PLATFORM_ID,
    HostListener,
    ViewChild,
    ElementRef,
    ViewEncapsulation
} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import Splide from '@splidejs/splide';
import {ResponseHandlerService} from 'src/app/core/services/common-service/response-handler.service';
import {lastValueFrom} from 'rxjs';
import {CommonConstants, RoutesConstants, ImageSizeConstants, ImagePathConstants} from '@coreconstant';
import {VenueVendorFooterComponent} from '../../venue-vendor-footer/venue-vendor-footer.component';
import {RequestParamModel} from 'src/app/core/models/request-param-model';
import {BlogService} from 'src/app/core/services/api-service/blog.service';
import {VendorService} from 'src/app/core/services/api-service/vendor.service';
import {Router, RouterModule} from '@angular/router';
import {SetImageDimensionsDirective} from 'src/app/core/directives/set-image-dimensions.directive';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {SeoService} from '../../../core/services/common-service/seo.service';
import {MetaDataConstants} from '../../../core/constants/meta-data-constants';
import {CountryService} from 'src/app/core/services/api-service/country.service';
import {StateService} from 'src/app/core/services/api-service/state.service';
import {VendorTypesService} from 'src/app/core/services/api-service/vendor-types.service';

@Component({
    selector: 'app-vendor-list',
    imports: [VenueVendorFooterComponent, SetImageDimensionsDirective, RouterModule, NgbTooltipModule],
    templateUrl: './vendor-list.component.html',
    styleUrls: ['../../venues/venue-list/venue-list.component.scss', './vendor-list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class VendorListComponent implements OnInit {
    requestParamModelForFeatured!: RequestParamModel;
    requestParamModel!: RequestParamModel;
    imagePathConstants = ImagePathConstants
    imageSizeConstants = ImageSizeConstants
    commonConstants = CommonConstants
    routesConstants = RoutesConstants
    isSticky: boolean = false;
    isClassToggled: boolean = false;
    countryList = []
    stateList = []
    filterStateList = []
    vendorTypeList = []
    selectedCountryIds = []
    selectedCountryNames = []
    firstSomeCountries = []
    selectedStateIds = []
    selectedStateNames = []
    firstSomeStates = []
    selectedRegionIds = []
    selectedRegionNames = []
    firstSomeRegions = []
    selectedVendorTypeIds = []
    selectedVendorTypeNames = []
    firstSomeVendorTypes = []
    filterOpen: string = ''
    featuredVendors = []
    vendorList = []
    currentPage = 1
    pageCount;
    totalCount = 0;
    isFilterApply = false
    vendorSplides: any
    splideInstances: any[] = [];
    vendorInspirationList = []
    stateData: any
    isRegionListEmpty: boolean = false;
    isGetResponse: boolean = false
    @ViewChild('parentSlider', {static: false}) parentSlider!: ElementRef;
    @ViewChild('vendorFilterWrap', {static: true}) vendorFilterWrap!: ElementRef;

    /**
     * Handles the window scroll event to determine the currently active section
     * in the viewport based on predefined section IDs.
     */
    @HostListener('window:scroll', [])
    onWindowScroll(): void {
        this.isSticky = window.scrollY > 10;
    }

    /**
     * Handles the click event on the document. Closes the vendor filter dropdown
     * if the click happens outside the referenced vendor filter wrapper element.
     * @param {Event} event - The click event object.
     */
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        if (this.vendorFilterWrap && !this.vendorFilterWrap.nativeElement.contains(event.target as Node)) {
            this.filterOpen = '';
        }
    }

    constructor(
        @Inject(PLATFORM_ID) private platformId: object,
        private _responseHandlerService: ResponseHandlerService,
        private _vendorService: VendorService,
        private _blogService: BlogService,
        private _seoService: SeoService,
        private _countryService: CountryService,
        private _stateService: StateService,
        private _vendorTypeService: VendorTypesService,
        private _router: Router
    ) {
        this.requestParamModelForFeatured = new RequestParamModel();
        this.requestParamModel = new RequestParamModel();
        this.requestParamModel.pageSize = this.commonConstants.PAGE_SIZE_COUNT
        this.requestParamModel.pageIndex = 1

        const navigation = this._router.getCurrentNavigation();
        this.stateData = navigation?.extras.state;

        this.setMetaTags()
    }

    /**
     * Sets the meta tags for the current page by creating a meta tag object and passes it to the SEO service for application.
     * @return {void} Does not return a value.
     */
    setMetaTags() {
        let metaTagObject = {
            title: MetaDataConstants.VENDOR_LIST.TITLE,
            description: MetaDataConstants.VENDOR_LIST.DESCRIPTION,
            ogImageUrl: MetaDataConstants.VENDOR_LIST.OGIMAGEURL,
            ogWebUrl: this.routesConstants.VENDOR_NAVIGATION,
        }
        this._seoService.setMetaTags(metaTagObject)
    }

    /**
     * Initializes the component and its dependent processes.
     */
    ngOnInit(): void {
        this.getCountries()
        this.getStates()
        this.getVendorTypes()

        this.getFeaturedVendorList()
        if (!(this.stateData && this.stateData['region'])) {
            this.getVendors()
        }
        this.getVendorInspiration()
    }

    /**
     * Initializes and configures the featured vendor list slider.
     * */
    featuredVendorListSlider() {
        if (isPlatformBrowser(this.platformId)) {

            // Initialize the parent slider
            if (this.parentSlider && this.parentSlider.nativeElement) {
                if (!this.parentSlider.nativeElement.classList.contains('featured-splide-initialized')) {
                    const parentSlider = new Splide(this.parentSlider.nativeElement, {
                        type: 'slide',
                        perPage: 4,
                        pagination: false,
                        arrows: true,
                        drag: false,
                        gap: '5px',
                        perMove: 1,
                        breakpoints: {
                            480: {
                                type: 'loop',
                                perPage: 2,
                                perMove: 1,
                                autoWidth: true,
                            },
                            767: {
                                type: 'loop',
                                perPage: 2,
                                perMove: 1,
                                autoWidth: true,
                            },
                            991: {
                                type: 'loop',
                                perPage: 3,
                                perMove: 1,
                                autoWidth: true,
                            },
                            1024: {
                                type: 'loop',
                                perPage: 4,
                                perMove: 1,
                                autoWidth: true,
                            }
                        },
                    });

                    parentSlider.on('mounted', () => {
                        this.featuredVendorListImageSlider()
                    });

                    // Mount the parent slider
                    parentSlider.mount();

                    // Mark this element as initialized
                    this.parentSlider.nativeElement.classList.add('featured-splide-initialized');
                }
            }
        }
    }

    /**
     * Initializes image slider elements for featured vendors.
     */
    featuredVendorListImageSlider() {
        if (isPlatformBrowser(this.platformId)) {
            // Find and initialize all nested sliders after the parent slider is mounted
            document.querySelectorAll('.featured-image-slider').forEach((sliderElement, index) => {
                // Avoid initializing the parent slider again
                if ((sliderElement as HTMLElement).id !== 'parent-slider') {

                    // Check if an instance already exists, if yes, destroy it
                    if (this.splideInstances[index]) {
                        this.splideInstances[index].destroy();
                    }

                    const featuredSplide = new Splide(sliderElement as HTMLElement, {
                        type: 'loop',
                        perPage: 1,
                        pagination: true,
                        arrows: true,
                        perMove: 1,
                    }).mount();

                    // Store the instance for future reference
                    this.splideInstances[index] = featuredSplide;
                }
            });
        }

    }

    /**
     * Initializes image sliders for vendor list by identifying elements with the
     * class 'box-slider' and setting up Splide instances for them if not already initialized.
     */
    vendorListImageSlider() {
        if (isPlatformBrowser(this.platformId)) {
            this.vendorSplides = [];
            const splides = document.querySelectorAll('.box-slider');

            splides.forEach((element) => {
                if (!element.classList.contains('splide-initialized')) {
                    const splide = new Splide(element as HTMLElement, {
                        type: 'loop',
                    }).mount();

                    this.vendorSplides.push(splide);

                    // Mark this element as initialized
                    element.classList.add('splide-initialized');
                }

            });
        }
    }

    /**
     * Reinitializes the slider for the vendor list images.
     */
    sliderReInit() {
        if (isPlatformBrowser(this.platformId)) {
            setTimeout(() => this.vendorListImageSlider(), 100); // Reinitialize after a short delay
        }
    }

    /**
     * Retrieves the list of countries.
     */
    getCountries() {
        const requestModel = new RequestParamModel();
        requestModel.addDefaultFilter('data', "all")
        delete requestModel.pageSize
        let getCountryList = this._countryService.getCountryList(requestModel)
        lastValueFrom(getCountryList).then((res: any) => {
            if (res["data"]) {
                this.countryList = res["data"]
            }
        }, (error: any) => {
            this._responseHandlerService.handleAPIErrorResponse(error)
        });
    }

    /**
     * Fetches the list of states.
     */
    getStates() {
        const requestModel = new RequestParamModel();
        requestModel.addDefaultFilter('data', "all")
        delete requestModel.pageSize
        let getStateList = this._stateService.getStateList(requestModel)
        lastValueFrom(getStateList).then((res: any) => {
            if (res["data"]) {
                this.stateList = res["data"]
                this.filterStateList = res["data"]
                setTimeout(() => {
                    if (this.stateData && this.stateData['region']) {
                        this.onSelectRegion(this.stateData['region'])
                        this.searchData()
                    }
                }, 0);
            }
        }, (error: any) => {
            this._responseHandlerService.handleAPIErrorResponse(error)
        });
    }

    /**
     * Fetches and processes the list of vendor types.
    */
    getVendorTypes() {
        const requestModel = new RequestParamModel();
        requestModel.addDefaultFilter('data', "all")
        delete requestModel.pageSize
        let getListing = this._vendorTypeService.getVendorTypeList(requestModel)
        lastValueFrom(getListing).then((res: any) => {
            if (res["data"]) {
                this.vendorTypeList = res["data"]
            }
        }, (error: any) => {
            this._responseHandlerService.handleAPIErrorResponse(error)
        });
    }

    /**
     * Handles the selection and deselection of a country, updating associated lists
     * of IDs and names for selected countries, states, and regions.
     * @param {Object} country - The country object containing its details.
     */
    onSelectCountry(country: any) {
        const index = this.selectedCountryIds.indexOf(country.id);
        if (index != -1) {
            this.selectedCountryIds.splice(index, 1);
        } else {
            this.selectedCountryIds.push(country.id);
        }

        this.selectedCountryNames = this.countryList
            .filter(country => this.selectedCountryIds.includes(country.id))
            .map(country => country.name);

        this.firstSomeCountries = this.selectedCountryNames.slice(0, this.commonConstants.MAX_SHOW_COUNT_FILTER);

        this.selectedStateIds = [], this.selectedStateNames = [], this.firstSomeStates = []
        this.selectedRegionIds = [], this.selectedRegionNames = [], this.firstSomeRegions = []
        this.isRegionListEmpty = false
    }

    /**
     * Handles the selection or deselection of a state. Updates the lists of selected state IDs,
     * selected state names, displayed state names, and resets region selection attributes.
     *
     * @param {Object} state - The state object that contains an `id` and other associated data.
     * @return {void} This method does not return any value.
     */
    onSelectState(state: any) {
        const index = this.selectedStateIds.indexOf(state.id);
        if (index != -1) {
            this.selectedStateIds.splice(index, 1);
        } else {
            this.selectedStateIds.push(state.id);
        }

        this.selectedStateNames = this.stateList
            .filter(state => this.selectedStateIds.includes(state.id))
            .map(state => state.name);

        this.firstSomeStates = this.selectedStateNames.slice(0, this.commonConstants.MAX_SHOW_COUNT_FILTER);

        this.selectedRegionIds = [], this.selectedRegionNames = [], this.firstSomeRegions = []
    }

    /**
     * Handles the selection and deselection of a region. Updates the list of selected region IDs,
     * retrieves the corresponding region names, and limits the displayed region names to a maximum count.
     * @param {Object} region - The region object containing region details such as id and name.
     */
    onSelectRegion(region: any) {
        const index = this.selectedRegionIds.indexOf(region.id);
        if (index != -1) {
            this.selectedRegionIds.splice(index, 1);
        } else {
            this.selectedRegionIds.push(region.id);
        }

        this.selectedRegionNames = this.stateList.reduce((result, state) => {
            const names = state.regionList
                .filter((region) => this.selectedRegionIds.includes(region.id))
                .map((region) => region.name);
            return result.concat(names);
        }, []);

        this.firstSomeRegions = this.selectedRegionNames.slice(0, this.commonConstants.MAX_SHOW_COUNT_FILTER);
    }

    /**
     * Manages the selection and deselection of vendor types, updating the list of selected vendor type IDs
     * and names, and maintaining a subset of selected vendor type names for display purposes.
     * @param {Object} type - The vendor type object that includes at least an `id` property and is used to update the selected vendor types.
     */
    onSelectVendorType(type: any) {
        const index = this.selectedVendorTypeIds.indexOf(type.id);
        if (index != -1) {
            this.selectedVendorTypeIds.splice(index, 1);
        } else {
            this.selectedVendorTypeIds.push(type.id);
        }

        this.selectedVendorTypeNames = this.vendorTypeList
            .filter(type => this.selectedVendorTypeIds.includes(type.id))
            .map(type => type.name);

        this.firstSomeVendorTypes = this.selectedVendorTypeNames.slice(0, this.commonConstants.MAX_SHOW_COUNT_FILTER);
    }

    /**
     * Toggles the button class for a specific filter and updates the filter state list
     * based on the provided filter name and selected
     * */
    toggleBtnClassForFilter(filterName: string): void {
        this.filterOpen = filterName

        if (filterName == 'state' || filterName == 'region') {
            if (this.selectedCountryIds.length > 0)
                this.filterStateList = this.stateList.filter(state => this.selectedCountryIds.includes(state.countryId))
            else
                this.filterStateList = this.stateList
        }

        if (filterName == 'region') {
            if (this.selectedStateIds.length > 0) {
                this.filterStateList = this.filterStateList.filter(state => this.selectedStateIds.includes(state.id))
                this.isRegionListEmpty = this.filterStateList.every(item => item.regionList.length === 0);
            }
        }
    }

    /**
     * Fetches the list of featured vendors by applying necessary filters
     * and updates the featuredVendors property with the retrieved data.
     */
    getFeaturedVendorList() {
        delete this.requestParamModelForFeatured.pageSize;
        this.requestParamModelForFeatured.addDefaultFilter('isFeatured', '1');

        let getListing = this._vendorService.getVendors(this.requestParamModelForFeatured)
        lastValueFrom(getListing).then((res: any) => {
            if (res["data"]) {
                this.featuredVendors = res["data"]
                setTimeout(() => {
                    this.featuredVendorListSlider()
                })
            }
        }, (error: any) => {
            this._responseHandlerService.handleAPIErrorResponse(error)
        });
    }

    /**
     * Fetches the list of vendors based on current filter settings and optionally appends the new data to an existing list.
     * @param {boolean} [isLoadMore=false] - Indicates whether to append the fetched vendors.
     */
    getVendors(isLoadMore: boolean = false) {
        this.isFilterApply = false
        this.requestParamModel.removeDefaultFilter('isFeatured');
        if (this.requestParamModel && this.requestParamModel.filter != '') {
            this.isFilterApply = true
        } else {
            this.requestParamModel.addDefaultFilter('isFeatured', '0');
        }

        let getListing = this._vendorService.getVendors(this.requestParamModel)
        lastValueFrom(getListing).then((res: any) => {
            this.currentPage = res["currentPage"]
            this.pageCount = res["pageCount"]
            this.totalCount = res["totalCount"]
            if (res["data"]) {
                this.isGetResponse = true
                let data = res["data"]
                if (isLoadMore)
                    this.vendorList = this.vendorList.concat(data)
                else
                    this.vendorList = data

                this.sliderReInit()

                if (!this.isFilterApply && this.featuredVendors && this.featuredVendors.length > 0) {
                    setTimeout(() => {
                        this.featuredVendorListSlider()
                    })
                }
            }
        }, (error: any) => {
            this._responseHandlerService.handleAPIErrorResponse(error)
        });
    }

    /**
     * Loads additional vendors by incrementing the page index.
     */
    loadMoreVendors() {
        this.requestParamModel.pageIndex = this.requestParamModel.pageIndex + 1
        this.getVendors(true)
    }

    /**
     * Searches and filters vendor data based on selected criteria including country, state, region, and vendor type.
     */
    searchData() {
        this.removeClass()
        this.filterOpen = ''
        this.requestParamModel.pageIndex = 1
        this.requestParamModel.removeFilter('countryId')
        this.requestParamModel.removeFilter('stateId')
        this.requestParamModel.removeFilter('regionId')
        this.requestParamModel.removeFilter('vendorTypesId')

        if (this.selectedCountryIds.length > 0)
            this.requestParamModel.setFilter('countryId', this.selectedCountryIds)

        if (this.selectedStateIds.length > 0)
            this.requestParamModel.setFilter('stateId', this.selectedStateIds)

        if (this.selectedRegionIds.length > 0)
            this.requestParamModel.setFilter('regionId', this.selectedRegionIds)

        if (this.selectedVendorTypeIds.length > 0)
            this.requestParamModel.setFilter('vendorTypesId', this.selectedVendorTypeIds)

        this.getVendors()
    }

    /**
     * Toggles the state of a class by switching its boolean value.
     */
    toggleClass(): void {
        this.isClassToggled = !this.isClassToggled;
    }

    /**
     * Removes a CSS class from an element or toggled state.
    */
    removeClass(): void {
        this.isClassToggled = false;
    }

    /**
     * Clears all the filter-related properties by resetting them to their default empty states.
     */
    clearAll() {
        this.filterOpen = ''
        this.selectedCountryIds = [], this.selectedCountryNames = [], this.firstSomeCountries = []
        this.selectedStateIds = [], this.selectedStateNames = [], this.firstSomeStates = []
        this.selectedRegionIds = [], this.selectedRegionNames = [], this.firstSomeRegions = []
        this.selectedVendorTypeIds = [], this.selectedVendorTypeNames = [], this.firstSomeVendorTypes = []
    }

    /**
     * Clears the current search filters, resets the page index to the first page.
     */
    clearSearch() {
        event.preventDefault()
        this.requestParamModel.pageIndex = 1
        this.requestParamModel.filter = '';
        this.clearAll();
        this.getVendors();
    }

    /**
     * Fetches a list of vendor inspirations blogs.
     */
    getVendorInspiration() {
        let requestModel = new RequestParamModel();
        requestModel.addDefaultFilter("type", "random")
        requestModel.pageSize = 4;
        let getListing = this._blogService.getBlogsList(requestModel)
        lastValueFrom(getListing).then((res: any) => {
            if (res["data"]) {
                this.vendorInspirationList = res["data"];
            }
        }, (error: any) => {
            this._responseHandlerService.handleAPIErrorResponse(error)
        });
    }

    /**
     * Sets the default image for an HTMLImageElement when an error occurs
     * @param {Event} event - The event object associated with the image load error.
     */
    setDefaultImage(event: Event) {
        let image = this.commonConstants.DEFAULT_NO_IMAGE;
        (event.target as HTMLImageElement).src = image
    }

}
